import { BoxExpanded, styled } from '@project-minerva/design-system'

export const ContentLayout = styled(BoxExpanded)(({ theme }) => ({
  width: '100%',
  maxWidth: '52.5rem',
  padding: theme.spacing(3),
}))
